function initRelatedSlider() {
  const container = document.querySelector(".related-products .grid");
  if (!container) return false;

  let index = 0;

  setInterval(() => {
    const items = container.querySelectorAll(".grid__item");
    if (!items.length) return;

    const itemWidth = items[0].offsetWidth + 16; // include gap
    const maxIndex = items.length - 4;

    index++;

    if (index > maxIndex) {
      index = 0;
    }

    container.scrollTo({
      left: index * itemWidth,
      behavior: "smooth"
    });
  }, 3000);

  return true;
}

/* IMPORTANT: product recommendations load late */
const observer = new MutationObserver(() => {
  const started = initRelatedSlider();
  if (started) observer.disconnect();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});